import "./CityGuide.module.css";
import MainNavigation from "@/reusable_sections/Header";
import FortLauderdaleEssentials from "./sections/FortLauderdaleEssentials";
import UpcomingCityEvents from "./sections/UpcomingCityEvents";
import SecurityIntelligenceFooter from "@/reusable_sections/Footer";
export default function CityGuidePage() {
  return <div>
      <MainNavigation />
      <FortLauderdaleEssentials />
      <UpcomingCityEvents />
      <SecurityIntelligenceFooter />
    </div>;
}